module.exports = __webpack_public_path__ + "img/live_xg.d83ed19c.png";